export default __webpack_public_path__ + "static/media/video_play.dec9f529.svg";